/* City Beauty Header - Shopify Compatible JavaScript */

// Global variables
// let productInfo = {}; // This will be populated from product-new.json
tcrParams = '';

// Cookie utility functions
function getRawCookie(name) {
  // Split cookie string and get all individual name=value pairs in an array
  var cookieArr = document.cookie.split(";");
  // Loop through the array elements
  for(var i = 0; i < cookieArr.length; i++) {
    var cookiePair = cookieArr[i].split("=");
    var cookiePair2 = cookieArr[i].split("|");
    // Removing whitespace at the beginning of the cookie name and compare it with the given string
    if(name === cookiePair[0].trim()) {
      // Decode the cookie value and return
      return decodeURIComponent(cookiePair2[1]);
    }
  }
  // Return null if not found
  return null;
}

// TCR Parameters handling
function initializeTCRParams() {
  var url = window.location.href;
  var domain = window.location.hostname;  
  var httpReferrer = document.referrer; 
  if( httpReferrer.toLowerCase().indexOf(domain) > -1){ httpReferrer = ""; } //Ignore referrer from native domain
  var dttcr = new Date();
  var queryString = url ? url.split('?')[1] : window.location.search.slice(1); 
  var urlParams = new URLSearchParams(queryString);
  var urlUtmCampaign = urlParams.get('utm_campaign');
   tcrParams = getRawCookie('tcrParams');
  
  if(tcrParams === '' || tcrParams === null || tcrParams === 'undefined' || tcrParams === undefined || (urlUtmCampaign !== undefined && urlUtmCampaign !== 'undefined' && urlUtmCampaign !== null && urlUtmCampaign !== '' && httpReferrer !== '') ) {

    dttcr.setTime(dttcr.getTime() + (1 * 24 * 60 * 60 * 1000)); // match the logged in cookie state 

    if( queryString !== undefined && queryString !== 'undefined' && queryString !== null && queryString !== ''){
      document.cookie = "tcrParams=|"+queryString+"; expires="+dttcr.toUTCString()+"; domain="+document.location.hostname+"; path=/";
      tcrParams = queryString;
    }
  }
}

// Mobile menu functionality
function initializeMobileMenu() {
  const mobileMenuToggle = document.getElementById('navbarLeft');
  const navbarCustomLeft = document.querySelector('.navbar-custom-left');

  if (mobileMenuToggle && navbarCustomLeft) {
    mobileMenuToggle.addEventListener('click', () => {
      toggleMobileMenu();
    });
  }

  // Function to toggle the mobile menu display
  function toggleMobileMenu() {
    navbarCustomLeft?.classList.toggle('open');
    // Toggle the body's overflow property
    document.body.style.overflow = navbarCustomLeft?.classList.contains('open') ? 'hidden' : 'auto';
  }

  // Close the mobile menu if a click occurs outside the menu
  document.body.addEventListener('click', (event) => {
    const isClickInsideMenu = navbarCustomLeft?.contains(event.target);
    if (!isClickInsideMenu && navbarCustomLeft?.classList.contains('open')) {
      toggleMobileMenu();
    }
  });
}

// Mobile search functionality
function initializeMobileSearch() {
  const mobileSearchToggle = document.getElementById('navbarRight');
  const navbarCustomRight = document.querySelector('.navbar-custom-right');

  if (mobileSearchToggle && navbarCustomRight) {
    mobileSearchToggle.addEventListener('click', toggleMobileSearchMenu);
  }

  function toggleMobileSearchMenu() {
    navbarCustomRight.classList.toggle('open');
  }
}

// Search functionality
function initializeSearch() {
  // Initialize products list HTML
  var productsListHtml = '';
  var dateObj = new Date();
  
  if (typeof productInfo === 'object' && productInfo !== null) {
    for (var key in productInfo) {
      let releaseDate = productInfo[key]["releaseDate"];

      const y = releaseDate.getFullYear();
      const m = releaseDate.getMonth()-1;
      const d = releaseDate.getDate();
      releaseDate = new Date(y, m, d);

      if (dateObj - releaseDate >= 0) {
        productsListHtml += '<li data-key="'+key+'"><a href="/'+productInfo[key]['product-link']+'">'+productInfo[key]['name']+'</a></li>\n';
      }
    }
  }

  // Populate search results when DOM is loaded
  document.addEventListener("DOMContentLoaded", function(event) {
    const searchResults = document.getElementsByClassName('search-results');
    if (searchResults[0]) {
      searchResults[0].innerHTML = productsListHtml;
    }
    if (searchResults[1]) {
      searchResults[1].innerHTML = productsListHtml;
    }
  });

  // Desktop search functionality
  function searchPageFilter(searchId) {
    var input = document.getElementById(searchId);
    var filter = input.value.trim().toUpperCase();
    var wrapperId = input.parentElement.parentElement;
    var productsWrappers = wrapperId.getElementsByTagName('li');

    input.parentElement.classList.add("active");

    for (i = 0; i < productsWrappers.length; i++) {
      var product = productsWrappers[i].getElementsByTagName("a")[0];
      var productValue = product.textContent || product.innerText;
      
      // Check if productValue is ERVC then update value to match json product-new.json key
      if(productValue == 'Essential Radiance') productValue = 'Essential Radiance Vegan Collagen'
      
      if (filter.length > 0) {
        wrapperId.querySelector('.reset-btn').style.display = 'initial';
        var areas = productInfo[productValue]["area"].toString().toUpperCase();
        if ('BODY'.indexOf(filter) > -1) {
          if (areas.indexOf('BODY') > -1) {
            productsWrappers[i].classList.add('active');
          }
        }
        else if ('FACE'.indexOf(filter) > -1) {
          if ((areas.indexOf('FACE') > -1 || areas.indexOf('SERUM') > -1) && areas.indexOf('EYE') == -1 && areas.indexOf('BODY') == -1) {
            productsWrappers[i].classList.add('active');
          }
        }
        else if (productValue.toUpperCase().indexOf(filter) > -1) {
          productsWrappers[i].classList.add('active');
        }
        else {
          productsWrappers[i].classList.remove('active');
        }
      } else {
        wrapperId.querySelector('.reset-btn').style.display = 'none';
        productsWrappers[i].classList.remove('active');
      }
    }
  }

  // Mobile search functionality
  function searchPageMobileFilter(searchId) {
    var input = document.getElementById(searchId);
    var filter = input.value.trim().toUpperCase();
    var wrapperId = input.parentElement.parentElement;
    var productsWrappers = wrapperId.getElementsByTagName('li');

    var searchResultsWrapper = document.querySelector('.search-results-wrapper');
    if (searchResultsWrapper) {
      searchResultsWrapper.style.display = 'block';
    }

    input.parentElement.classList.add("active");

    for (i = 0; i < productsWrappers.length; i++) {
      var productValue = productsWrappers[i]?.dataset.key;
      
      // Check if productValue is ERVC then update value to match json product-new.json key
      if(productValue == 'Essential Radiance') productValue = 'Essential Radiance Vegan Collagen'
      
      if (filter.length > 0) {
        wrapperId.querySelector('.reset-btn').style.display = 'initial';
        var areas = productInfo[productValue]["area"].toString().toUpperCase();
        if ('BODY'.indexOf(filter) > -1) {
          if (areas.indexOf('BODY') > -1) {
            productsWrappers[i].classList.add('active');
          }
        }
        else if ('FACE'.indexOf(filter) > -1) {
          if ((areas.indexOf('FACE') > -1 || areas.indexOf('SERUM') > -1) && areas.indexOf('EYE') == -1 && areas.indexOf('BODY') == -1) {
            productsWrappers[i].classList.add('active');
          }
        }
        else if (productValue.toUpperCase().indexOf(filter) > -1) {
          productsWrappers[i].classList.add('active');
        }
        else {
          productsWrappers[i].classList.remove('active');
        }
        // Update mobile search results with enhanced display
        productsWrappers[i].innerHTML = `<a href="${productInfo[productValue]['product-link']}"><div class="row align-items-center mb-3">
                                          <div class="col-auto pl-0">
                                            <img src="${productInfo[productValue]['non-hover-img']}" alt="${key}" class="img-fluid">
                                          </div>
                                          <div class="col align-self-baseline pr-5">
                                            <h6 class="font-weight-bold mb-0">${productInfo[productValue]['name']}</h6>
                                            <p class="mb-0 text-muted">${productInfo[productValue]['product-info']}</p>
                                          </div>
                                        </div></a>`;
      } else {
        wrapperId.querySelector('.reset-btn').style.display = 'none';
        if (searchResultsWrapper) {
          searchResultsWrapper.style.display = 'none';
        }
        productsWrappers[i].classList.remove('active');
      }
    }
  }

  // Reset search input functionality
  function resetSearchInput() {
    let target = document.querySelector('#nav-search .input-group');

    target.querySelector('input').value = '';
    target.querySelector('.reset-btn').style.display = 'none';
    let activeList = target.parentElement.getElementsByClassName('active');
    
    const activeListLength = activeList.length;
    for (var i = activeListLength - 1; i >= 0; i--) {
      activeList[i].classList.remove('active');
    }

    target.classList.remove('active');
  }

  // Event listeners for search
  var desktopSearch = document.querySelector('#nav-search');
  var mobileSearch = document.querySelector('#nav-search-mobile');
  const searchResultsWrapper = document.querySelector('.search-results-wrapper');
    
  document.body.addEventListener('click', function (event) {
    if (desktopSearch && !desktopSearch.contains(event.target)) {
      resetSearchInput();
    }
    if (mobileSearch && !mobileSearch.contains(event.target)) {
      document.querySelector('#nav-search-mobile .search-results').style.display='none';
    }
  });

  // Reset button event listeners
  const resetBtnDesktop = document.querySelector('#nav-search .reset-btn');
  const resetBtnMobile = document.querySelector('#nav-search-mobile .reset-btn');

  if (resetBtnDesktop) {
    resetBtnDesktop.addEventListener('click', function(event) {
      resetSearchInput();
    });
  }

  if (resetBtnMobile) {
    resetBtnMobile.addEventListener('click', function(event) {
      if (searchResultsWrapper) {
        searchResultsWrapper.style.display = 'none';
      }
      document.getElementById('nav-search-mobile').querySelector('input').value = '';
    });
  }

  // Mobile search focus events
  const mobileSearchInput = document.getElementById('mobile-search-page-input');
  if (mobileSearchInput) {
    mobileSearchInput.addEventListener('focus', function(e){
      const searchWrapper = e.target.closest('.search-wrapper');
      if (searchWrapper) {
        const searchResults = searchWrapper.querySelector('.search-results');
        if (searchResults) {
          searchResults.style.display = 'block';
        }
      }
    });
  }

  // Reset button event listeners for keyboard
  document.querySelectorAll('.reset-btn').forEach(function(item) {
    item.addEventListener('mousedown', function(event) {
      event.preventDefault();
    });
    item.addEventListener('keyup', function(event) {
      event.preventDefault();
      if (event.keyCode === 13) {
        item.click();
      }
    });
  });

  // Make functions globally available
  window.searchPageFilter = searchPageFilter;
  window.searchPageMobileFilter = searchPageMobileFilter;
}

// Cart functionality
function initializeCart() {
   tcrParams = getRawCookie('tcrParams');
  if(!(tcrParams === '' || tcrParams === null || tcrParams === 'undefined' || tcrParams === undefined)) {
    const cartLinks = document.getElementsByClassName("cart-href");
    for (let i = 0; i < cartLinks.length; i++) {
      if (cartLinks[i].href.indexOf('?') > -1) {
        cartLinks[i].href = cartLinks[i].href + '&' + tcrParams;
      } else {
        cartLinks[i].href = cartLinks[i].href + '?' + tcrParams;
      }
    }
  }
}

// Bootstrap CSS fallback test
function initializeBootstrapFallback() {
  // Skip Bootstrap CSS fallback to prevent 404 errors
  // Bootstrap functionality is handled by existing CSS
  return;
}

// Initialize all functionality when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
  // Initialize all components
  initializeTCRParams();
  initializeMobileMenu();
  initializeMobileSearch();
  initializeSearch();
  initializeCart();
  initializeBootstrapFallback();

  // Hide search results wrapper initially
  const searchResultsWrapper = document.querySelector('.search-results-wrapper');
  if (searchResultsWrapper) {
    searchResultsWrapper.style.display = 'none';
  }
});

// Export functions for Shopify compatibility
if (typeof module !== 'undefined' && module.exports) {
  module.exports = {
    getRawCookie,
    initializeTCRParams,
    initializeMobileMenu,
    initializeMobileSearch,
    initializeSearch,
    initializeCart,
    initializeBootstrapFallback
  };
}
